import { Injectable } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import { ControlInterface, selectControlValue } from '@comparit/core';
import { map, startWith } from 'rxjs';
import { MarkedItem } from '../interfaces/marked-item.model';
import { SortErgebnisEnum } from '../interfaces/sort-ergebnis-enum.model';

export interface CalculatorInput {
  compare: MarkedItem[]; // berechnungstoken
  bausteine: MarkedItem[]; // kombinationId
  sortBy: SortErgebnisEnum;
  sortDescending: boolean;
}

export class CalculatorForm {
  constructor(
    private fb: NonNullableFormBuilder,
    private defaultValue?: CalculatorInput | null
  ) {}

  ctrls: ControlInterface<CalculatorInput> = {
    compare: this.fb.control<MarkedItem[]>(this.defaultValue?.compare ?? []),
    bausteine: this.fb.control<MarkedItem[]>(this.defaultValue?.bausteine ?? []),
    sortBy: this.fb.control<SortErgebnisEnum>(
      this.defaultValue?.sortBy ?? SortErgebnisEnum.Beitrag
    ),
    sortDescending: this.fb.control<boolean>(this.defaultValue?.sortDescending ?? false),
  };

  public compare$ = selectControlValue(this.ctrls.compare);
  public bausteine$ = selectControlValue(this.ctrls.bausteine);
  public sortBy$ = selectControlValue(this.ctrls.sortBy);
  public sortDescending$ = selectControlValue(this.ctrls.sortDescending);

  toggleCompare(item: MarkedItem) {
    const current = [...this.ctrls.compare.value];
    this._addOrSlice(current, item);
    this.ctrls.compare.setValue(current);
  }

  toggleBausteine(item: MarkedItem) {
    const current = [...this.ctrls.bausteine.value];
    this._addOrSlice(current, item);
    this.ctrls.bausteine.setValue(current);
  }

  toggleSortDesc() {
    this.ctrls.sortDescending.setValue(!this.ctrls.sortDescending.value);
  }

  private _addOrSlice = (list: MarkedItem[], data: MarkedItem) => {
    const index = list.findIndex(item => item.kombinationId === data.kombinationId);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(data);
    }
  };

  public isTarifeSelected$ = (tarif: MarkedItem) => {
    return this.compare$.pipe(
      map(compare => !!compare.find(item => tarif.kombinationId === item.kombinationId))
    );
  };

  private fg = this.fb.group(this.ctrls);

  private fgValueChanges$ = this.fg.valueChanges.pipe(map(() => this.fg.getRawValue()));

  private fgValue$ = this.fg.valueChanges.pipe(
    startWith(null),
    map(() => this.fg.getRawValue())
  );

  public form = {
    fgCtrls: this.ctrls,
    fgValue$: this.fgValue$,
    fgValueChanges$: this.fgValueChanges$,
    fgDefaultValue: this.fg.getRawValue(),
  };

  reset() {
    this.fg.setValue(this.form.fgDefaultValue);
  }
}

@Injectable({ providedIn: 'root' })
export class CalculatorService {}
